(function () {
  'use strict';

  var STORAGE_KEY = 'mct-theme';
  var DEFAULT     = 'dark';

  // Apply saved theme immediately (before paint) to avoid flash
  function applyTheme(mode) {
    document.documentElement.setAttribute('data-mct-theme', mode);
  }

  var saved = localStorage.getItem(STORAGE_KEY) || DEFAULT;
  applyTheme(saved);

  // Wire up toggle button(s) after DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mct-toggle]').forEach(function (btn) {
      updateIcon(btn, saved);
      btn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-mct-theme') || DEFAULT;
        var next    = current === 'dark' ? 'light' : 'dark';
        applyTheme(next);
        localStorage.setItem(STORAGE_KEY, next);
        document.querySelectorAll('[data-mct-toggle]').forEach(function (b) {
          updateIcon(b, next);
        });
      });
    });
  });

  function updateIcon(btn, mode) {
    btn.setAttribute('title', mode === 'dark' ? 'Helles Design' : 'Dunkles Design');
    btn.textContent = mode === 'dark' ? '☀' : '☾';
  }
})();
